import React, { useState } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  Link,
  useColorModeValue,
  useToast,
  Container
} from "@chakra-ui/react";
import api from "../../../services/api";
import menomV2Logo from "../../../assets/img/menomV2Logo.png";

function ForgotPassword() {
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = useColorModeValue("gray.400", "gray.300");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/api/business/auth/forgot-password', { email });

      if (response.data?.success) {
        toast({
          title: "Email gönderildi",
          description: response.data.message || "Şifre sıfırlama linki email adresinize gönderildi. Lütfen email kutunuzu kontrol edin.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        
        // 2 saniye sonra login sayfasına yönlendir
        setTimeout(() => {
          navigate('/auth/sign-in');
        }, 2000);
      }
    } catch (error) {
      toast({
        title: "Hata",
        description: error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center" py={8}>
      <Container maxW="md">
        <Flex
          direction="column"
          w="100%"
          bg="white"
          borderRadius="xl"
          boxShadow="xl"
          p={8}
        >
          <Flex direction="column" align="center" mb={8}>
            <Box mb={4}>
              <img src={menomV2Logo} alt="Menom" style={{ height: '80px', width: 'auto' }} />
            </Box>
            <Heading size="xl" color={textColor} mb={2}>
              Şifremi Unuttum
            </Heading>
            <Text color={textColorSecondary} fontSize="sm" textAlign="center">
              Email adresinize şifre sıfırlama linki göndereceğiz
            </Text>
          </Flex>

          <form onSubmit={handleSubmit}>
            <FormControl mb={6}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Email
              </FormLabel>
              <Input
                variant="auth"
                fontSize="sm"
                type="email"
                placeholder="mail@sirket.com"
                mb="24px"
                fontWeight="500"
                size="lg"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </FormControl>

            <Button
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mb="24px"
              type="submit"
              isLoading={loading}
            >
              Şifre Sıfırlama Linki Gönder
            </Button>

            <Flex justifyContent="center" alignItems="center">
              <Text color={textColorSecondary} fontWeight="400" fontSize="14px">
                Şifrenizi hatırladınız mı?{" "}
                <Link
                  as={RouterLink}
                  to="/auth/sign-in"
                  color="brand.500"
                  fontWeight="500"
                  textDecoration="none"
                  _hover={{ textDecoration: "none" }}
                >
                  Giriş Yap
                </Link>
              </Text>
            </Flex>
          </form>
        </Flex>
      </Container>
    </Box>
  );
}

export default ForgotPassword;
